namespace GeniuzPOS.ReportMasterData {
    export class Report_1502_NColumns {
        static columnsKey = 'ReportMasterData.Report_1502_N';
    }
}
